import { KeyValue } from '@/main/models/common';
import { PartBrandTypes, PartBrandActionTypes } from './partBrandTypes';

export function getTireBrand(idBrandType: number): PartBrandActionTypes {
  return {
    type: PartBrandTypes.GET_TIRE_BRAND,
    payload: { idBrandType }
  };
}

export function saveTireBrand(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): PartBrandActionTypes {
  return {
    type: PartBrandTypes.SAVE_TIRE_BRAND,
    payload: { data, isError, errorMessages }
  };
}
